import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 2000 },
    modal: { type: String, default: "feedback-modal" }
  }

  connect() {
    this.timeout = setTimeout(() => {
      const modal = this.element.closest(`[data-controller~='${this.modalValue}']`)
      if (!modal) return

      const controller = this.application.getControllerForElementAndIdentifier(modal, this.modalValue)
      controller?.close()
    }, this.delayValue)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
